<template>
    <div>
        <div class="row d-flex align-items-center mt-5">
            <div class="col-sm-6">
                <h4>OVP darba apstākļi</h4>
            </div>
            <div class="col-sm-6 d-flex justify-content-around">
                <OvpJobConditionsAdd/>
            </div>
        </div>
        <OvpJobConditionList :hasSearch="true"/>
    </div>
</template>
<script>
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';

    import OvpJobConditionsAdd from './OvpJobConditionsAdd';
    import OvpJobConditionList from './OvpJobConditionList';   

    export default {
        name: 'ovp-job-conditions',
        components: {OvpJobConditionList, OvpJobConditionsAdd},
        data: () => ({skeletonData: SkeletonLoaderRepository.usersListLayout}),
    }
</script>